(function () {
  function initStickyBuy(bar) {
    if (!bar || bar.dataset.dtInitialized === "true") return;

    var productId = bar.dataset.productId;
    var productSection = document.querySelector('.product-section[data-product-id="' + productId + '"]');
    if (!productSection) return;

    var nativeButton = productSection.querySelector('[data-add-to-cart]');
    var stickyButton = bar.querySelector('[data-dt-sticky-button]');
    var stickyButtonText = bar.querySelector('[data-dt-sticky-button-text]');
    var stickyVariant = bar.querySelector('[data-dt-sticky-variant]');
    var price = bar.querySelector('[data-dt-sticky-price]');
    var compare = bar.querySelector('[data-dt-sticky-compare]');
    var image = bar.querySelector('.dt-sticky-buy__image');
    var footer = document.querySelector('.site-footer');

    if (!nativeButton || !stickyButton) return;
    bar.dataset.dtInitialized = "true";

    var footerVisible = false;
    var ticking = false;

    function formatMoney(cents) {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
      return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function syncNativeButton() {
      stickyButton.disabled = nativeButton.disabled;
      var nativeText = nativeButton.querySelector('[data-add-to-cart-text]');
      if (nativeText && stickyButtonText) stickyButtonText.textContent = nativeText.textContent.trim();
    }

    function updateVariant(variant) {
      if (!variant) {
        stickyButton.disabled = true;
        if (stickyButtonText && window.theme && theme.strings) {
          stickyButtonText.textContent = theme.strings.unavailable;
        }
        return;
      }

      if (price) price.innerHTML = formatMoney(variant.price);

      var onSale = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
      if (compare) {
        compare.hidden = !onSale;
        compare.innerHTML = onSale ? formatMoney(variant.compare_at_price) : '';
      }

      stickyButton.disabled = !variant.available;
      if (stickyVariant) stickyVariant.textContent = variant.title || '';
      if (stickyButtonText && window.theme && theme.strings) {
        var nativeText = nativeButton.querySelector('[data-add-to-cart-text]');
        var availableText = nativeText
          ? (nativeText.dataset.defaultText || nativeText.textContent.trim())
          : nativeButton.textContent.trim();
        stickyButtonText.textContent = variant.available
          ? availableText
          : theme.strings.soldOut;
      }

      if (image && variant.featured_image && variant.featured_image.src) {
        image.src = variant.featured_image.src;
        image.removeAttribute('srcset');
      }

      window.setTimeout(syncNativeButton, 0);
    }

    function updateVisibility() {
      ticking = false;
      var nativeRect = nativeButton.getBoundingClientRect();
      var hasPassedNativeButton = nativeRect.bottom < 0;
      if (footer && !('IntersectionObserver' in window)) {
        var footerRect = footer.getBoundingClientRect();
        footerVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;
      }
      var visible = hasPassedNativeButton && !footerVisible;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function requestVisibilityUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    }

    stickyButton.addEventListener('click', function () {
      if (!stickyButton.disabled) nativeButton.click();
    });

    productSection.addEventListener('variantChange', function (event) {
      updateVariant(event.detail && event.detail.variant);
    });

    new MutationObserver(syncNativeButton).observe(nativeButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true
    });

    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries.some(function (entry) { return entry.isIntersecting; });
        requestVisibilityUpdate();
      }, { threshold: 0 }).observe(footer);
    }

    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate);
    syncNativeButton();
    updateVisibility();
  }

  function initAll() {
    document.querySelectorAll('[data-dt-sticky-buy]').forEach(initStickyBuy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
